import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { ThemingService } from '@app/shared/services/theming.service';
import { TranslateModule } from '@ngx-translate/core';
import { UpperCasePipe } from '@angular/common';

@Component({
  selector: 'slotcom-game-tier',
  templateUrl: './game-tier.component.html',
  styleUrls: ['./game-tier.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TranslateModule, UpperCasePipe],
})
export class GameTierComponent implements OnInit {
  @Input() gameTier: string;

  tierImage: string;

  private readonly themingService = inject(ThemingService);

  ngOnInit(): void {
    this.tierImage = this.themingService.getThemeAsset('none', `pl-tier-${this.gameTier}`);
  }
}
